// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld-base';
import pageHtml from 'text!html/phone/phone.html';
import 'myWorld/layouts/phone/phoneLayoutDetails';

myw.PhoneLayoutStreetviewPage = myw.PhoneLayoutDetails.extend({
    attributes: {
        id: 'page-street-view'
    },

    /*
     * @class Page view for displaying the streetview of to the current feature
     * @param  {PhoneLayout}  owner   The owner of self.
     * @extends {PhoneLayoutDetails}
     * @constructs
     */
    initialize(owner) {
        const options = { prevPageName: 'page-details' };
        myw.PhoneLayoutDetails.prototype.initialize.call(this, owner, options);
        this.$('.phone-layout-details-container').prop('id', 'street-view-large-container');
    }
});

export default myw.PhoneLayoutStreetviewPage;
